"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconCheck = _interopRequireDefault(require("@instructure/ui-icons/lib/Line/IconCheck"));

var _IconX = _interopRequireDefault(require("@instructure/ui-icons/lib/Line/IconX"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'baKaw',
  template: function template(theme) {
    return "\n\n.baKaw_bGBk{align-items:center;display:flex}\n\n.baKaw_bGBk .baKaw_cSXm.baKaw_cjfS{background:".concat(theme.checkedBackground || 'inherit', ";box-shadow:none}\n\n.baKaw_bGBk .baKaw_cSXm.baKaw_cjfS .baKaw_dnnz{transform:translate3d(50%,0,0)}\n\n.baKaw_bGBk .baKaw_cSXm.baKaw_cjfS .baKaw_eoCh{color:").concat(theme.checkedIconColor || 'inherit', "}\n\n.baKaw_bGBk .baKaw_cSXm.baKaw_cVYB:before{opacity:1;transform:scale(1)}\n\n[dir=rtl] .baKaw_bGBk .baKaw_cSXm.baKaw_cjfS .baKaw_dnnz{transform:translate3d(-50%,0,0)}\n\n.baKaw_cSXm{-moz-user-select:none;-ms-user-select:none;-webkit-margin-end:").concat(theme.marginEnd || 'inherit', ";-webkit-margin-start:0;-webkit-user-select:none;background:").concat(theme.background || 'inherit', ";border-color:").concat(theme.borderColor || 'inherit', ";border-radius:3rem;box-shadow:inset 0 0 0 ").concat(theme.borderWidth || 'inherit', " ").concat(theme.borderColor || 'inherit', ";cursor:pointer;display:inline-block;margin-inline-end:").concat(theme.marginEnd || 'inherit', ";margin-inline-start:0;position:relative;user-select:none;vertical-align:middle}\n\n[dir=ltr] .baKaw_cSXm{margin-left:0;margin-right:").concat(theme.marginEnd || 'inherit', "}\n\n[dir=rtl] .baKaw_cSXm{margin-left:").concat(theme.marginEnd || 'inherit', ";margin-right:0}\n\n.baKaw_cSXm:before{border:").concat(theme.focusBorderWidth || 'inherit', " ").concat(theme.focusBorderStyle || 'inherit', " ").concat(theme.focusOutlineColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";box-sizing:border-box;content:\"\";height:calc(100% + 0.5rem);left:-0.25rem;opacity:0;pointer-events:none;top:-0.25rem;transform:scale(0.75);width:calc(100% + 0.5rem)}\n\n.baKaw_cSXm:before,.baKaw_dnnz{position:absolute;transition:all 0.2s}\n\n.baKaw_dnnz{display:block;inset-inline-end:auto;inset-inline-start:0;text-align:center;top:0;transform:translateZ(0)}\n\n[dir=ltr] .baKaw_dnnz{left:0;right:auto;text-align:center}\n\n[dir=rtl] .baKaw_dnnz{left:auto;right:0;text-align:center}\n\n.baKaw_cMpH{align-items:center;display:flex;height:100%;justify-content:center;position:relative;width:100%}\n\n.baKaw_cMpH:before{background:").concat(theme.toggleBackground || 'inherit', ";border-radius:100%;box-shadow:").concat(theme.toggleShadow || 'inherit', ";content:\"\";height:calc(100% - ").concat(theme.borderWidth || 'inherit', "*2);left:").concat(theme.borderWidth || 'inherit', ";position:absolute;top:").concat(theme.borderWidth || 'inherit', ";width:calc(100% - ").concat(theme.borderWidth || 'inherit', "*2)}\n\n.baKaw_eoCh{color:").concat(theme.uncheckedIconColor || 'inherit', ";display:block;position:relative;z-index:1}\n\n.baKaw_blJt{color:").concat(theme.labelColor || 'inherit', ";flex:1;font-family:").concat(theme.labelFontFamily || 'inherit', ";font-weight:").concat(theme.labelFontWeight || 'inherit', ";line-height:").concat(theme.labelLineHeight || 'inherit', ";min-width:0.0625rem}\n\n.baKaw_doqw{width:calc(").concat(theme.baseSizeSmall || 'inherit', "*1.5)}\n\n.baKaw_doqw,.baKaw_doqw .baKaw_dnnz{height:").concat(theme.baseSizeSmall || 'inherit', "}\n\n.baKaw_doqw .baKaw_dnnz{font-size:0.875rem;width:").concat(theme.baseSizeSmall || 'inherit', "}\n\n.baKaw_doqw+.baKaw_blJt{font-size:").concat(theme.labelFontSizeSmall || 'inherit', "}\n\n.baKaw_ycrn{width:calc(").concat(theme.baseSizeMedium || 'inherit', "*1.5)}\n\n.baKaw_ycrn,.baKaw_ycrn .baKaw_dnnz{height:").concat(theme.baseSizeMedium || 'inherit', "}\n\n.baKaw_ycrn .baKaw_dnnz{font-size:1.125rem;width:").concat(theme.baseSizeMedium || 'inherit', "}\n\n.baKaw_ycrn+.baKaw_blJt{font-size:").concat(theme.labelFontSizeMedium || 'inherit', "}\n\n.baKaw_cMDj{width:calc(").concat(theme.baseSizeLarge || 'inherit', "*1.5)}\n\n.baKaw_cMDj,.baKaw_cMDj .baKaw_dnnz{height:").concat(theme.baseSizeLarge || 'inherit', "}\n\n.baKaw_cMDj .baKaw_dnnz{font-size:1.5rem;width:").concat(theme.baseSizeLarge || 'inherit', "}\n\n.baKaw_cMDj+.baKaw_blJt{font-size:").concat(theme.labelFontSizeLarge || 'inherit', "}");
  },
  'root': 'baKaw_bGBk',
  'facade': 'baKaw_cSXm',
  'checked': 'baKaw_cjfS',
  'icon': 'baKaw_dnnz',
  'iconSVG': 'baKaw_eoCh',
  'focused': 'baKaw_cVYB',
  'iconToggle': 'baKaw_cMpH',
  'label': 'baKaw_blJt',
  'small': 'baKaw_doqw',
  'medium': 'baKaw_ycrn',
  'large': 'baKaw_cMDj'
};
var ToggleFacade = (
/**
---
parent: Checkbox
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ToggleFacade, _Component);

  function ToggleFacade() {
    (0, _classCallCheck2.default)(this, ToggleFacade);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToggleFacade).apply(this, arguments));
  }

  (0, _createClass2.default)(ToggleFacade, [{
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.checked) {
        return _react.default.createElement(_IconCheck.default, {
          className: styles.iconSVG
        });
      } else {
        return _react.default.createElement(_IconX.default, {
          className: styles.iconSVG
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          size = _this$props.size,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          focused = _this$props.focused;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.facade, true), (0, _defineProperty2.default)(_classes, styles.checked, checked), (0, _defineProperty2.default)(_classes, styles.disabled, disabled), (0, _defineProperty2.default)(_classes, styles.focused, focused), (0, _defineProperty2.default)(_classes, styles[size], true), _classes);
      return _react.default.createElement("span", {
        className: styles.root
      }, _react.default.createElement("span", {
        className: (0, _classnames.default)(classes),
        "aria-hidden": "true"
      }, _react.default.createElement("span", {
        className: styles.icon
      }, _react.default.createElement("span", {
        className: styles.iconToggle
      }, this.renderIcon()))), _react.default.createElement("span", {
        className: styles.label
      }, this.props.children));
    }
  }]);
  ToggleFacade.displayName = "ToggleFacade";
  return ToggleFacade;
}(_react.Component), _class2.propTypes = {
  children: _propTypes.default.node.isRequired,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  focused: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
}, _class2.defaultProps = {
  checked: false,
  focused: false,
  size: 'medium',
  disabled: false,
  readOnly: false
}, _temp)) || _class);
exports.default = ToggleFacade;